<template>
  <div class="card">
    <div class="top">
      <!-- <h2>EPISODIO 1</h2> -->
      <img :src="require(`../assets/images/${img}`)" alt="DiDi Lab Shark Tank" />
    </div>
    <p>
      <b>Episodio {{number}}</b>
      <br>
      {{description}}
    </p>
    <button @click="watchVideo(id)">Ver episodio {{number}}</button>
  </div>
</template>

<script>
export default {
  props: ["watchVideo", "id", "description", "img", "number"],
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;

  @include phone {
    margin-bottom: 2rem;
  }

  .top {
    position: relative;
    display: flex;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    h2 {
      color: #bebebe;
      opacity: 0.64;
      font-weight: normal;
      position: absolute;
      bottom: 0.75rem;
      left: 0.75rem;
    }
  }
  p {
    background: rgba($color: #ffffff, $alpha: 0.3);
    padding: 0.5rem 1rem;
    color: white;
    font-weight: normal;
    font-size: 0.8rem;
    min-height: 90px;

    b {
      font-size: 0.9rem;
    }
  }
  button {
    background: #ff7d41;
    color: white;
    border-radius: 50px;
    padding: 0.5rem 1rem;
    margin-top: 1.5rem;
  }
}
</style>